"use client";

import { Suspense } from "react";

import {
  ApplicationFormController,
  PersonalStatementPage,
  ProgramSelectionPage,
  StudentInformationPage1Adult,
  StudentInformationPage2Adult,
} from "@up/application-form";

import { AcademicInformationPageAdult } from "~/components/application/Academic";

const pages = [
  StudentInformationPage1Adult,
  StudentInformationPage2Adult,
  ProgramSelectionPage,
  AcademicInformationPageAdult,
  PersonalStatementPage,
];

const CompleteErrorMessageOverride = function CompleteErrorMessageOverride({
  message,
  navigate,
}: {
  message: string;
  navigate: (page: number) => void;
}) {
  if (message.match(/selections/)) {
    return (
      <div className="mb-2">
        <button
          className="mr-2 underline"
          onClick={() => {
            navigate(3);
          }}
        >
          Page 3
        </button>{" "}
        Please make at least one course selection
      </div>
    );
  } else if (message.match(/student/)) {
    if (message.match(/student\.phone/)) {
      return (
        <div className="mb-2">
          <button
            className="mr-2 underline"
            onClick={() => {
              navigate(2);
            }}
          >
            Page 2
          </button>{" "}
          Please provide student phone number
        </div>
      );
    } else {
      return (
        <div className="mb-2">
          <button
            className="mr-2 underline"
            onClick={() => {
              navigate(1);
            }}
          >
            Page 1
          </button>{" "}
          Please complete student information
        </div>
      );
    }
  } else if (message.match(/education/)) {
    return (
      <div className="mb-2">
        <button
          className="mr-2 underline"
          onClick={() => {
            navigate(4);
          }}
        >
          Page 4
        </button>{" "}
        Please complete education information
      </div>
    );
  } else {
    return (
      <div className="mb-2">
        There are some outstanding issues with your application.{" "}
        <button
          onClick={() => {
            navigate(1);
          }}
        >
          Please review from the start of page 1
        </button>
        . Once you&apos;ve resolved all issues you will be able to complete your
        application.
      </div>
    );
  }
};

export default function ApplicationPage() {
  return (
    <div className="theme-white">
      <Suspense>
        <ApplicationFormController
          CompleteErrorMessageOverride={CompleteErrorMessageOverride}
          pages={pages}
        />
      </Suspense>
    </div>
  );
}
